export default __webpack_public_path__ + "static/media/47.01b8756e.png";